/**
 * Show all dates JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class ShowAllDates
 */
class ShowAllDates {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.additionalDates     = $( '#js-event-additional-times' );
        this.showAllDatesButton  = $( '#js-show-all-dates' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Show all dates when clicking the button
        this.showAllDatesButton.on( 'click', () => {
            this.additionalDates.children().removeClass( 'transparent-date js-hidden' );

            // Remove the button when the dates are visible
            this.showAllDatesButton.remove();
        });
    }

    /**
     * Hide all the dates after the 4th one, make the third one transparent
     */
    hideDates() {
        this.additionalDates.children( ':nth-child( 3 )' ).addClass( 'transparent-date' );
        this.additionalDates.children( ':nth-child( n+4 )' ).not( this.showAllEventsButton ).addClass( 'js-hidden' );
    }


    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.hideDates();
    }
}

// Export the class reference.
module.exports = ShowAllDates;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/event-dates.js